import InputProfile from './InputProfile.react';
import DropdownProfileStates from './DropdownProfileStates';
import UserStore from '../../../stores/UserStore';

const CustomerProfilePOS = 'Customer Profile (POS)';

class ProfileAddresses extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        var selectedLocation = UserStore.getState().selectedLocation;

        var street = 'street',
            postal = 'postal_code',
            city = 'city',
            county = 'county';

        if (this.props.newAddress) {
            street = 'newStreet';
            postal = 'newPostal';
            city = 'newCity';
            county = 'newCounty';
        }

        return (
            <div>
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'address') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field={street}
                                disabled={this.props.isAnonymous}
                                value={this.props.street}
                                onChange={this.props.onChange}
                                address={this.props.address}
                                newAddress={this.props.newAddress} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Street {UserStore.isFieldRequired(CustomerProfilePOS, 'address') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'city') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field={city}
                                disabled={this.props.isAnonymous}
                                value={this.props.city}
                                onChange={this.props.onChange}
                                address={this.props.address}
                                newAddress={this.props.newAddress} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                City {UserStore.isFieldRequired(CustomerProfilePOS, 'city') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'postal_code') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field={postal}
                                disabled={this.props.isAnonymous && !selectedLocation.CollectAnonymousDemo}
                                value={this.props.postal}
                                onChange={this.props.onChange}
                                address={this.props.address}
                                newAddress={this.props.newAddress} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Postal Code {UserStore.isFieldRequired(CustomerProfilePOS, 'postal_code') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'county') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfileStates
                                field={county}
                                disabled={this.props.isAnonymous}
                                selected={this.props.county}
                                onChange={this.props.onChange}
                                address={this.props.address}
                                newAddress={this.props.newAddress} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                State {UserStore.isFieldRequired(CustomerProfilePOS, 'county') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default ProfileAddresses;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ProfileAddresses.react.jsx